import * as React from 'react';
import { Loader as Loader2 } from 'lucide-react';
import { cn } from '@/platform/ui/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function LoadingSpinner({ className, size = 'md', label }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Loader2 className={cn('animate-spin text-muted-foreground', sizeMap[size])} />
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  );
}

interface LoadingStateProps {
  className?: string;
  label?: string;
  minHeight?: string;
}

export function LoadingState({ className, label, minHeight = 'min-h-40' }: LoadingStateProps) {
  return (
    <div className={cn('flex items-center justify-center', minHeight, className)}>
      <LoadingSpinner label={label} />
    </div>
  );
}
